import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class UserManager {
  async saveUserInfo(user) {
    try {
      await PBStorage.set(LOCAL_STORAGE_KEYS.USER, user);
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
}

export default new UserManager();
